/**
 * Hook for the Crew Chat hub — the cross-task chat index (demo #8).
 *
 * Reads GET /crew-chat/threads: every task crew-chat the caller can access as a
 * flat list (crew → their assigned tasks; supervisor/admin → all), whether or
 * not the task has any messages yet. The page sorts/searches/groups it. Pass
 * includeCompleted to also return completed/cancelled tasks ("Show completed").
 * The per-task posting/reading still flows through the task-messages hooks.
 */
import { useQuery } from '@tanstack/react-query';
import type { CrewChatThreadsResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export function useCrewChatThreads(includeCompleted = false) {
  return useQuery<CrewChatThreadsResponse>({
    queryKey: ['crew-chat', 'threads', { includeCompleted }],
    queryFn: () =>
      apiCall<CrewChatThreadsResponse>(
        `/crew-chat/threads${includeCompleted ? '?include_completed=true' : ''}`,
      ),
    staleTime: 10_000,
    refetchInterval: 30_000,
  });
}
